<template>
    <header class="bg-gray-200 pt-2">
        <div class="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
            <div class="flex h-16 items-center justify-between">
                <div class="md:flex md:items-center md:gap-12">
                    <RouterLink to="/" class="block text-teal-600">
                        <img class="w-full h-auto object-cover" src="../../assets/logo_pick&log.png" alt="Pick&Log">
                    </RouterLink>
                </div>

                <div class="flex items-center gap-4">
                    <div class="sm:flex sm:gap-4">
                        <RouterLink v-if="!checkUserAuth && !checkRouterLogin"
                            class="rounded-md px-5 py-2.5 text-sm font-medium shadow transition-colors duration-300 custom-nav-button hover:ring-1 hover:ring-orange-400"
                            to="/">
                            Login
                        </RouterLink>

                        <!-- Drawer para usuario autenticado -->
                        <div v-if="checkUserAuth" class="drawer drawer-end">
                            <input id="user-drawer" type="checkbox" class="drawer-toggle" />
                            
                            <!-- Trigger button -->
                            <div class="drawer-content">
                                <label for="user-drawer" 
                                    class="flex capitalize rounded-md px-3 py-2.5 gap-1 text-sm font-medium shadow transition-colors duration-300 custom-nav-button hover:ring-1 hover:ring-orange-400 cursor-pointer">
                                    <span>Panel</span>
                                    <BurguerMenu />
                                </label>
                            </div>
                            
                            <!-- Sidebar -->
                            <div class="drawer-side z-50">
                                <label for="user-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
                                <LoginNavbar @close-drawer="closeDrawer" :seller_name="getUserAuthenticated.seller_name" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>





<script setup lang="ts">
import { computed, ref } from 'vue';
import LoginNavbar from './LoginNavbar.vue';
import { useUserAuthenticatedStore } from '../AuthComponent/stores/UserAuthenticated.store';
import { useRoute } from 'vue-router';
import BurguerMenu from './Sub-Components/BurguerMenu.vue';


const route = useRoute()



const store = useUserAuthenticatedStore()

const checkUserAuth = computed(() => store.checkUserAuth)
const getUserAuthenticated = computed(() => store.getUserAuthenticated)


const isMenuOpen = ref(false)

const checkRouterLogin = computed(() => {
    return route.fullPath === '/' ? true : false;
})

const closeDrawer = () => {
    const drawerToggle = document.getElementById('user-drawer') as HTMLInputElement;
    if(drawerToggle) {
        drawerToggle.checked = false
    }
}


// @ts-ignore
const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
}




</script>



<style scoped>
/* Efectos para el dropdown cuando el usuario este logueado */
.menu-enter-active,
.menu-leave-active {
    transition: all 0.4s ease;
}

.menu-enter-from,
.menu-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

/* Colores y efectos para los botones de navegacion */
.custom-nav-button {
    background-color: #f1b15a;
    color: white;
}

.custom-nav-button:hover {
    background-color: #f3bc74;
}

.custom-nav-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(241, 177, 90, 0.5);
}


.register-text {
    color: #f1b15a
}
</style>